export function callbackSyncShoppingCart(context, warenkorbId) {
    const htmlCallback = `
    <callback-app callback="syncShoppingCart">
        <callback-param key="shoppingCartId" value="${warenkorbId}"></callback-param>
    </callback-app>`;
    context.insertAdjacentHTML('afterbegin', htmlCallback);
}